import Vue from "vue"
import {
	createRouter,
	createWebHistory
} from 'vue-router'
import {childrenRoute} from './childrenRoute.js'

const routes = [
	{
		path: '/',
		name: 'Home',
		meta:{
			title:'易知网'
		},
		component: () => import('../views/Home.vue')
	},
	{
		path: '/searchPage',
		name: 'searchPage',
		meta:{
			title:'搜索详情',
		},
		component: () => import('../components/search/searchPage.vue')
	},
	{
		path: '/:catchAll(.*)',
		component:() => import('../components/page404.vue')
	},           //404页面
	{
		path: '/',
		name: 'Home',
		meta:{
			title:'易知网'
		},
		component: () => import('../views/Home.vue')
	},
	// 知识产权研究院首页
	{
		path: '/irpi',
		name: 'irpi',
		meta:{
			title:'知识产权研究院'
		},
		component: () => import('../irpi/irpi.vue')
	},
	// 团队建设-组织结构
	{
		path: '/structure',
		name: 'structure',
		component: () => import('../irpi/views/teamBuilding/structure.vue')
	},
	// 团队建设-专家简介
	{
		path: '/expert',
		name: 'expert',
		component: () => import('../irpi/views/teamBuilding/expert.vue')
	},
	// 服务内容-金融服务
	{
		path: '/finance',
		name: 'finance',
		component: () => import('../irpi/views/service/finance.vue')
	},
	// 服务内容-知识产权托管
	{
		path: '/intellectualProperty',
		name: 'intellectualProperty',
		component: () => import('../irpi/views/service/intellectualProperty.vue')
	},
	// 服务内容-专利导航
	{
		path: '/patentNav',
		name: 'patentNav',
		component: () => import('../irpi/views/service/patentNav.vue')
	},
	//服务内容-人才培养
	{
		path: '/personnel',
		name: 'personnel',
		component: () => import('../irpi/views/service/personnel.vue')
	},
	// 行业资讯
	{
		path: '/news',
		name: 'news',
		component: () => import('../irpi/views/news/news.vue')
	},
	// 知识产权研究院新闻详情页
	{
		path: '/irpiNewsDetail',
		name: 'irpiNewsDetail',
		component: () => import('../irpi/views/newsDetail/newsDetail.vue')
	},
	// 联系我们
	{
		path: '/contactUs',
		name: 'contactUs',
		component: () => import('../irpi/views/contactUs/contactUs.vue')
	},
	// ↓↓↓↓↓↓↓↓↓↓↓↓ 易知网 ↓↓↓↓↓↓↓↓↓↓↓↓↓
	// 交易商城-商标交易
	{
		path:'/brand',
		name: 'brand',
		meta:{
			title:'商标交易'
		},
		component: () => import('../views/transaction/brand.vue')
	},
	// 交易商城-专利交易
	{
		path:'/patent',
		name: 'patent',
		meta:{
			title:'专利交易'
		},
		component: () => import('../views/transaction/patent.vue')
	},
	// 交易商城-商标分类查询列表
	{
		path:'/trademarkList',
		name: 'trademarkList',
		component: () => import('../views/transaction/list/trademarkList.vue')
	},
	// 交易商城-专利分类查询详情页
	{
		path:'/patentList',
		name: 'patentList',
		component: () => import('../views/transaction/list/patentList.vue')
	},
	// 交易商城-专利交易
	{
		path:'/newsInformation',
		name: 'newsInformation',
		meta:{
			title:'行业资讯'
		},
		component: () => import('../views/newsInformation/newsInformation.vue')
	},
	// 专利求购
	{
		path:'/purchaseList',
		name: 'purchaseList',
		component: () => import('../views/patentPurchase/purchaseList.vue')
	},
	// 专利求购详情页
	{
		path:'/purchaseDetail',
		name: 'purchaseDetail',
		component: () => import('../views/patentPurchase/purchaseDetail.vue')
	},
	// 专家介绍
	{
		path:'/expertDesc',
		name: 'expertDesc',
		component: () => import('../views/expertDesc/expertDesc.vue')
	},
	// 基础服务-主页
	{
		path:'/basicServices',
		name: 'basicServices',
		meta:{
			title:'基础服务'
		},
		component: () => import('../views/basicServices/basicServices.vue')
	},
	// 基础服务-各业务列表页
	{
		path:'/serviceList',
		name: 'serviceList',
		meta:{
			title:'基础服务'
		},
		component: () => import('../views/basicServices/serviceList.vue')
	},
	// 关于我们
	{
		path:'/aboutUs',
		name: 'aboutUs',
		meta:{
			title:'关于我们'
		},
		component: () => import('../views/aboutUs/aboutUs.vue')
	},
	// 关于我们列表
	{
		path:'/aboutUsList',
		name: 'aboutUsList',
		component: () => import('../views/aboutUs/list/index.vue'),
		children:childrenRoute
	},
	// 个人中心
	{
		path:'/personal',
		name: 'personal',
		component: () => import('../views/personal/personal.vue')
	},
	// 商品详情页面
	{
		path:'/newsDetail',
		name:'newsDetail',
		component: () => import('../views/newsDetail/newsDetail.vue')
	},
	// 新闻详情页面
	{
		path:'/goodsInfo',
		name:'goodsInfo',
		component: () => import('../views/goodsInfo/goodsInfo.vue')
	},
	// 登录界面
	{
		path:'/login',
		name:'Login',
		component: () => import('../views/login/login.vue')
	},
	//专利查询
	{
		path:'/zlQuery',
		name: 'zlQuery',
		meta:{
			title:'专利查询'
		},
		component: () => import('../views/zlQuery/zlQuery.vue')
	},
	// 专利查询详情页
	{
		path:'/zlQueryList:queryFrom',
		name: 'zlQueryList',
		meta:{
			title:'专利查询列表'
		},
		component: () => import('../views/zlQueryList/zlQueryList.vue')
	},
	// 专利查询详情页
	{
		path:'/zlDetail:queryId',
		name: 'zlDetail',
		meta:{
			title:'专利详情'
		},
		component: () => import('../views/zlDetail/zlDetail.vue')
	},
	//收藏夹专利列表
	{
		path:'/zlByCollection:collectionId',
		name: 'zlByCollection',
		meta:{
			title:'收藏夹专利'
		},
		component: () => import('../views/zlByCollection/zlByCollection.vue')
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
	// 获取token
	let token = window.sessionStorage.getItem('token')
	let user = window.sessionStorage.getItem('user')
	if(token){ // 已登录
		// 防止重复登录
		if(to.path === '/login'){
			return next({name:from.name ? from.name : '/'})
		}
		// 其他验证...
		if(to.name !== 'error_404'){
			if(user){
				user = JSON.parse(user)
				if(user.super === 1){
					return next()
				}
			}
		}
		next();
	} else {
		// 跳过登录页验证
		if(to.path === '/login'){
			return next();
		}
		if(to.path === '/personal'){
			return next('/')
		}
		// 未登录
		next()
	}
})
export default router
